import { Button, Col, Grid, Image, Row, Typography } from 'antd';

import ImageC from 'src/components/Image';

import classes from './index.module.less';

const GenerateJobsForBaby = () => {
	const { xs } = Grid.useBreakpoint();

	return (
		<div className={classes.pagehero}>
			<div className={classes['page-body-wrap']}>
				<div className="container">
					<Row>
						<Col 
							xs={{ span: 24, order: 2 }}
							sm={{ span: 24, order: 2 }}
							md={{ span: 24, order: 2 }}
							lg={{ span: 12, order: 1 }}
							xl={{ span: 12, order: 1 }}
						>
							<div className={classes.imgbabyText}>
								<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 12 }}>
									<p className={classes.title} style={{ margin: 0 }}>
										Si Kecil Jadi Apa?	
									</p>
									<div>
										{ !xs &&
											<Image
												src="/images/generateJob/starbabyAI.svg"
												alt="icon"
												width={88}
												height={77}
												preview={false}
												style={{ marginTop: '-50px', marginLeft: '40px'}}
											/>
										}
									</div>
								</div>	
								<Typography className={classes.paragraph}>
									Yuk, lihat keseruan Si Kecil menjadi cita-citanya!, Uploadfoto Si Kecil, Pilih cita-citanya, dan lihat hasilnya dalam ilustrasi yang menggemaskan
								</Typography>

								<div className={classes.btnFooter}>
									<Button
										className={classes.btn}
										size="large"
										id="sikecil-jadi-apa-coba-sekarang"
										href='/sikecil-jadi-apa'
									>
										<span className={classes.btnContent}>
											<span className={classes.btnText}>Coba Sekarang  </span>
											<Image
												src="/images/generateAi/btn-icon.svg"
												alt="icon"
												width={24}
												height={24}
												preview={false}
												className={classes.btnIcon}
											/>
										</span>
									</Button>
								</div>
							</div>
						</Col>
						<Col 
							xs={{ span: 24, order: 1 }}
							sm={{ span: 24, order: 1 }}
							md={{ span: 24, order: 1 }}
							lg={{ span: 12, order: 2 }}
							xl={{ span: 12, order: 2 }}
						>
							<div className={classes.imgbabyAI}>
								<ImageC
									src="/images/generateJob/branda-section-professi.webp"
									width={xs ? 340 : 560}
									height={xs ? 260 : 373} />

							</div>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default GenerateJobsForBaby;
